const UNAVAILABLE_TOKENS = [
  'stub',
  'mock',
  'mockmode',
  'mock_mode',
  'mock-mode',
  'mock mode',
  'fallback',
  'fallback_used',
  'fallback-used',
  'fallback used',
  'mock_fallback',
  'mock-fallback',
  'mock fallback',
  'fail',
  'failed',
  'failure',
  'failclosed',
  'fail_closed',
  'fail-closed',
  'fail closed',
  'placeholder',
  'placeholder_mode',
  'placeholder-mode',
  'placeholder mode',
  'placeholder_response',
  'placeholder-response',
  'placeholder response',
  'error',
  'false',
  'false_proof',
  'false-proof',
  'false proof',
  'falseproof',
  '-1',
  '400',
  '401',
  '403',
  '404',
  '500',
  'read_only',
  'read_only_mode',
  'read-only-mode',
  'read only mode',
  'readonlymode',
  'read_only_query',
  'read-only-query',
  'read only query',
  'read_only_reward',
  'read-only-reward',
  'read only reward',
  'readonlyreward',
  'readonly',
  'readonlyquery',
  'read only',
  'read-only',
  'data_unavailable',
  'data-unavailable',
  'data unavailable',
  'dataunavailable',
  'unimplemented',
  'not_implemented',
  'not implemented',
  'unsupported',
  'disabled',
  'unavailable',
  'write_blocked',
  'writeblocked',
  'write blocked',
  'write-blocked',
  'blocked',
  'backend_blocked',
  'backendblocked',
  'backend blocked',
  'backend-blocked',
  'payment_backend_blocked',
  'paymentbackendblocked',
  'payment backend blocked',
  'payment-backend-blocked',
  'payment_status_unconfirmed',
  'paymentstatusunconfirmed',
  'payment status unconfirmed',
  'payment-status-unconfirmed',
  'not_connected',
  'not-connected',
  'not connected',
  'read_failure',
  'read-failure',
  'read failure',
  'read_failed',
  'read-failed',
  'read failed',
  'route_unavailable',
  'route-unavailable',
  'route unavailable',
  'routeunavailable',
  'technical_marker',
  'technical-marker',
  'technical marker',
  'technicalmarker',
  'technical_error',
  'technical-error',
  'technical error',
  'technicalerror',
  'technical_exception',
  'technical-exception',
  'technical exception',
  'technicalexception',
  'backend_failure',
  'backend-failure',
  'backend failure',
  'backendfailure',
  'need_login',
  'not_supported',
  'not supported',
  'query_only',
  'query only',
  'only support query',
  'only supports query',
  '只支持查询',
  '仅支持查询',
  '技术错误',
  '技术异常'
]
const ENVELOPE_KEYS = ['content', 'payload', 'body', 'extra', 'page', 'data', 'list', 'records', 'dataList']
const DIAGNOSTIC_ENVELOPE_KEYS = ['diagnostics', 'diagnostic', 'meta', 'metadata', 'detail', 'details', 'errors', 'error', 'trace']
const SCAN_ENVELOPE_KEYS = [...ENVELOPE_KEYS, ...DIAGNOSTIC_ENVELOPE_KEYS]
const MAX_ENVELOPE_DEPTH = 6
const SERVER_READ_PROOF_KEYS = ['serverReadProof', 'server_read_proof', 'readProof', 'read_proof']
const PAYLOAD_HINT_KEYS = [
  'paymentList',
  'quickSelect',
  'awardRules',
  'activities',
  'firstRecharge',
  'orderNo',
  'orderId',
  'recordNo',
  'payOrderNo',
  'paymentOrderNo',
  'paymentNo',
  'tradeNo',
  'paymentKey',
  'paymentId',
  'channelId',
  'channelCode',
  'payUrl',
  'paymentUrl',
  'cashierUrl',
  'checkoutUrl',
  'redirectUrl',
  'qrcode',
  'qrCode',
  'paymentAmount',
  'amount',
  'minAmount',
  'maxAmount',
  'rechargeFees',
  'balance',
  '_balUsable',
  '_account',
  'account',
  'payStatus',
  'paymentStatus',
  'orderStatus',
  'tradeStatus'
]
const METADATA_KEYS = [
  'status',
  'state',
  'result',
  'code',
  'errorCode',
  'success',
  'msg',
  'message',
  'errorMsg',
  'errorMessage',
  'reason',
  'desc',
  'description',
  'detail'
]
const NEED_LOGIN_KEYS = [
  'needLogin',
  'need_login',
  'loginRequired',
  'login_required',
  'status',
  'state',
  'code',
  'errorCode',
  'msg',
  'message',
  'errorMsg',
  'errorMessage',
  'reason',
  'desc',
  'description',
  'detail'
]

// Marker keys that are commonly attached as top-level "notes" (mock/fallback/read-only)
// while the real payment payload is nested deeper inside the response.
const RESPONSE_MARKER_KEYS = [
  'readOnly',
  'read_only',
  'readOnlyQuery',
  'read_only_query',
  'readOnlyMode',
  'read_only_mode',
  'readOnlyAction',
  'read_only_action',
  'readOnlyReward',
  'read_only_reward',
  'readOnlyMessage',
  'readonly',
  'mock',
  'mockMode',
  'mock_mode',
  'mockFallback',
  'mock_fallback',
  'stub',
  'placeholder',
  'placeholderMode',
  'placeholder_mode',
  'placeholderResponse',
  'placeholder_response',
  'fallback',
  'fallbackUsed',
  'fallback_used',
  'failClosed',
  'fail_closed',
  'unimplemented',
  'notImplemented',
  'not_implemented',
  'notSupported',
  'not_supported',
  'unsupported',
  'dataUnavailable',
  'data_unavailable',
  'readBlocked',
  'read_blocked',
  'readUnavailable',
  'read_unavailable',
  'routeUnavailable',
  'route_unavailable',
  'notConnected',
  'not_connected',
  'queryOnly',
  'query_only',
  'onlyQuery',
  'only_query',
  'writeBlocked',
  'write_blocked',
  'backendBlocked',
  'backend_blocked',
  'paymentBackendBlocked',
  'payment_backend_blocked',
  'paymentStatusUnconfirmed',
  'payment_status_unconfirmed',
  'falseProof',
  'false_proof',
  'blocked',
  'needLogin',
  'need_login',
  'readFailure',
  'read_failure',
  'readFailed',
  'read_failed'
]
const RESPONSE_METADATA_KEYS = [...METADATA_KEYS, ...RESPONSE_MARKER_KEYS]
export const FUNDS_GENERIC_FAILURE_MESSAGE = 'La demande a échoué, veuillez réessayer plus tard.'
export const FUNDS_UNAVAILABLE_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
export const FUNDS_READ_FAILURE_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
export const FUNDS_DATA_UNAVAILABLE_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'

function safeGetStorageItem(storage, key, fallback = '') {
  if (!storage || typeof storage.getItem !== 'function') return fallback
  try {
    const value = storage.getItem(key)
    return value == null ? fallback : value
  } catch (e) {
    return fallback
  }
}

function safeSetStorageItem(storage, key, value) {
  if (!storage || typeof storage.setItem !== 'function') return false
  try {
    storage.setItem(key, value)
    return true
  } catch (e) {
    return false
  }
}

function safeRemoveStorageItem(storage, key) {
  if (!storage || typeof storage.removeItem !== 'function') return false
  try {
    storage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}

function getBrowserWindow() {
  try {
    if (typeof window !== 'undefined' && window) return window
  } catch (e) {
    return null
  }
  return null
}

function getBrowserGlobal() {
  try {
    if (typeof Function !== 'function') return null
    const root = Function('return this')()
    return root || null
  } catch (e) {
    return null
  }
}

function getStorageHosts() {
  const hosts = []
  const browser = getBrowserWindow()
  if (browser) hosts.push(browser)
  const root = getBrowserGlobal()
  if (root && root !== browser) hosts.push(root)
  return hosts
}

function getBrowserStorage(key) {
  for (const host of getStorageHosts()) {
    try {
      const storage = host && host[key]
      if (storage) return storage
    } catch (e) {
      // Try the next host.
    }
  }
  return null
}

function getLocalStorage() {
  return getBrowserStorage('localStorage')
}

function getSessionStorage() {
  return getBrowserStorage('sessionStorage')
}

export function isNeedLogin(res) {
  const data = requestErrorPayload(res)
  const bodies = responseBodies(data)
  const content = contentOf(data)
  const flags = [
    data && data.needLogin,
    data && data.need_login,
    content.needLogin,
    content.need_login,
    ...bodyValues(bodies, ['needLogin', 'need_login'])
  ]
  if (flags.some(isNeedLoginFlag)) return true
  return !!(data && [
    ...NEED_LOGIN_KEYS.map((key) => data[key]),
    ...NEED_LOGIN_KEYS.map((key) => content[key]),
    ...bodyValues(bodies, NEED_LOGIN_KEYS)
  ].some(isNeedLoginToken))
}

function unavailableToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function isNeedLoginToken(value) {
  const token = unavailableToken(value)
  if (!token) return false
  if ([
    'need_login',
    'needlogin',
    'login_required',
    'login required',
    'unauthorized',
    'not_authorized',
    'not authorized',
    'token_expired',
    'expired_token',
    'login_expired',
    'session_expired',
    '401'
  ].includes(token)) return true
  if (token.includes('need_login') || token.includes('needlogin')) return true
  if (token.includes('login_required') || token.includes('login required')) return true
  if (token.includes('unauthorized') || token.includes('not_authorized') || token.includes('not authorized')) return true
  if (token.includes('token_expired') || token.includes('expired_token')) return true
  if (token.includes('login_expired') || token.includes('session_expired')) return true
  if (token.includes('token') && token.includes('expired')) return true
  if (token.includes('session') && token.includes('expired')) return true
  return /(^|[^\d])401($|[^\d])/.test(token)
}

function isNeedLoginFlag(value) {
  const token = unavailableToken(value)
  return value === true ||
    value === 1 ||
    ['true', '1', 'yes', 'on'].includes(token) ||
    isNeedLoginToken(value)
}

export function isGenericFailureMessage(value) {
  const token = unavailableToken(value)
  return !token ||
    token === 'network error' ||
    token.includes('network error') ||
    token === 'networkerror' ||
    token === 'error' ||
    token === 'request failed' ||
    token.startsWith('request failed ') ||
    token === 'requestfailed' ||
    token.startsWith('timeout ') ||
    token.includes(' timeout') ||
    token.includes('timeout of ') ||
    token.includes('exceeded') ||
    token === 'fallback'
}

export function fundingFailureFallback(fallback, defaultMessage = FUNDS_GENERIC_FAILURE_MESSAGE) {
  return isGenericFailureMessage(fallback) || hasRawTechnicalDetail(fallback) ? defaultMessage : fallback
}

function hasRawTechnicalDetail(value) {
  const token = unavailableToken(value)
  return token.includes('http://') ||
    token.includes('https://') ||
    token.includes('request failed') ||
    token.includes('status code') ||
    token.includes('stack trace') ||
    token.includes('paymenthandler') ||
    token.includes('payment handler') ||
    token.includes('org.springframework') ||
    token.includes('com.valoran')
}

export function requestErrorPayload(error) {
  if (!error || typeof error !== 'object') return error
  if (error.response && typeof error.response === 'object') {
    if (error.response.data !== undefined) return error.response.data
    if (error.response.body !== undefined) return error.response.body
  }
  if (error.cause && typeof error.cause === 'object') {
    const causePayload = requestErrorPayload(error.cause)
    if (causePayload && causePayload !== error.cause) return causePayload
  }
  return error instanceof Error ? null : error
}

function isUnavailableToken(value) {
  const token = unavailableToken(value)
  return Boolean(token) && (
    UNAVAILABLE_TOKENS.includes(token) ||
    isBlockedToken(token) ||
    token.includes('mock') ||
    token.includes('read_only') ||
    token.includes('read_only_mode') ||
    token.includes('read-only-mode') ||
    token.includes('read only mode') ||
    token.includes('readonlymode') ||
    token.includes('read_only_query') ||
    token.includes('read_only_reward') ||
    token.includes('read only query') ||
    token.includes('read only reward') ||
    token.includes('read-only-query') ||
    token.includes('read-only-reward') ||
    token.includes('readonlyreward') ||
    token.includes('readonlyquery') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token.includes('data_unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('data unavailable') ||
    token.includes('dataunavailable') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('need_login') ||
    token.includes('needlogin') ||
    token.includes('login_required') ||
    token.includes('login required') ||
    token.includes('token_expired') ||
    token.includes('expired_token') ||
    token.includes('login_expired') ||
    token.includes('session_expired') ||
    token.includes('false_proof') ||
    token.includes('false-proof') ||
    token.includes('false proof') ||
    token.includes('falseproof') ||
    token.includes('write_blocked') ||
    token.includes('writeblocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('payment_backend_blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('payment_status_unconfirmed') ||
    token.includes('paymentstatusunconfirmed') ||
    token.includes('payment status unconfirmed') ||
    token.includes('payment-status-unconfirmed') ||
    token.includes('unsupported') ||
    token.includes('not_supported') ||
    token.includes('not supported') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('read_failure') ||
    token.includes('read-failure') ||
    token.includes('read failure') ||
    token.includes('read_failed') ||
    token.includes('read-failed') ||
    token.includes('read failed') ||
    token.includes('route_unavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route unavailable') ||
    token.includes('routeunavailable') ||
    token.includes('technical_marker') ||
    token.includes('technical-marker') ||
    token.includes('technical marker') ||
    token.includes('technicalmarker') ||
    token.includes('query_only') ||
    token.includes('query only') ||
    token.includes('only support query') ||
    token.includes('only supports query') ||
    token.includes('只支持查询') ||
    token.includes('仅支持查询') ||
    token.includes('技术错误') ||
    token.includes('技术异常')
  )
}

function isHardUnavailableText(value) {
  const token = unavailableToken(value)
  return isUnavailableToken(value) && (
    token.includes('route_unavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route unavailable') ||
    token.includes('routeunavailable') ||
    token.includes('technical_marker') ||
    token.includes('technical-marker') ||
    token.includes('technical marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical_error') ||
    token.includes('technical-error') ||
    token.includes('technical error') ||
    token.includes('technicalerror') ||
    token.includes('technical_exception') ||
    token.includes('technical-exception') ||
    token.includes('technical exception') ||
    token.includes('technicalexception') ||
    token.includes('backend_failure') ||
    token.includes('backend-failure') ||
    token.includes('backend failure') ||
    token.includes('backendfailure') ||
    token.includes('技术错误') ||
    token.includes('技术异常')
  )
}

function isBlockedToken(value) {
  const token = unavailableToken(value)
  if (!token || token.includes('unblocked') || token.includes('not blocked')) return false
  return token === 'block' ||
    token === 'blocked' ||
    token === 'backendblocked' ||
    token === 'backendfailure' ||
    token === 'paymentbackendblocked' ||
    token.includes('backend_blocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend_failure') ||
    token.includes('backend failure') ||
    token.includes('backend-failure') ||
    token.includes('payment_backend_blocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    /(^|[\s_-])blocked($|[\s_-])/.test(token)
}

function isActiveGuardFlag(value) {
  const token = unavailableToken(value)
  return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(token)
}

function isActiveGuardMarker(value) {
  const token = unavailableToken(value)
  if (!token || value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)) return false
  return isActiveGuardFlag(value) || isUnavailableToken(value)
}

function isUnavailableResponseMarker(value) {
  const token = unavailableToken(value)
  if (!token || value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)) return false
  return isUnavailableToken(value)
}

function isMetadataOnlyResponseText(value) {
  const token = unavailableToken(value)
  return Boolean(token) && (
    token.includes('metadata-only') ||
    token.includes('metadata only')
  )
}

function isUnavailableResponseMarkerForPayload(value, hasBusinessPayload) {
  if (hasBusinessPayload && isMetadataOnlyResponseText(value)) return false
  return isUnavailableResponseMarker(value)
}

function isStrictUnavailableMarker(value) {
  const token = unavailableToken(value)
  if (!token || value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)) return false
  if (isActiveGuardFlag(value)) return true
  return UNAVAILABLE_TOKENS.includes(token) || isBlockedToken(token)
}

function isFalseProofMarker(value) {
  const token = unavailableToken(value)
  return value === false || value === 0 || ['false', '0', 'no', 'off'].includes(token)
}

function hasServerReadProof(payload, content = contentOf(payload), bodies = responseBodies(payload)) {
  return [payload, content, ...bodies].some((source) => {
    if (!source || typeof source !== 'object') return false
    return SERVER_READ_PROOF_KEYS.some((key) => isPositiveFlag(source[key]))
  })
}

function readOnlyQueryGuardValues(payload, content = contentOf(payload), bodies = responseBodies(payload)) {
  if (hasServerReadProof(payload, content, bodies)) return []
  return [
    payload && payload.readOnlyQuery,
    payload && payload.read_only_query,
    content.readOnlyQuery,
    content.read_only_query,
    ...bodyValues(bodies, ['readOnlyQuery', 'read_only_query'])
  ]
}

export function hasUnavailableMarker(payload) {
  if (!payload || typeof payload !== 'object') return false
  if (hasConfirmedPaymentReadyPayload(payload)) return false
  const content = contentOf(payload)
  const bodies = responseBodies(payload)
  const hasBusinessPayload = hasPayloadFields(content)
  const directFlags = [
    payload.readOnly,
    payload.read_only,
    payload.readOnlyReward,
    payload.read_only_reward,
    payload.readOnlyAction,
    payload.read_only_action,
    payload.readOnlyMode,
    payload.read_only_mode,
    payload.fallback,
    payload.fallbackUsed,
    payload.fallback_used,
    payload.failClosed,
    payload.fail_closed,
    payload.mock,
    payload.mockMode,
    payload.mock_mode,
    payload.mockFallback,
    payload.mock_fallback,
    payload.readonly,
    payload.placeholder,
    payload.placeholderMode,
    payload.placeholder_mode,
    payload.placeholderResponse,
    payload.placeholder_response,
    payload.unimplemented,
    payload.dataUnavailable,
    payload.data_unavailable,
    payload.readBlocked,
    payload.read_blocked,
    payload.readUnavailable,
    payload.read_unavailable,
    payload.routeUnavailable,
    payload.route_unavailable,
    payload.technicalError,
    payload.technical_error,
    payload.technicalMarker,
    payload.technical_marker,
    payload.technicalException,
    payload.technical_exception,
    payload.notImplemented,
    payload.not_implemented,
    payload.stub,
    payload.writeBlocked,
    payload.write_blocked,
    payload.blocked,
    payload.backendBlocked,
    payload.backend_blocked,
    payload.backendFailure,
    payload.backend_failure,
    payload.paymentBackendBlocked,
    payload.payment_backend_blocked,
    payload.paymentStatusUnconfirmed,
    payload.payment_status_unconfirmed,
    payload.falseProof,
    payload.false_proof,
    payload.needLogin,
    payload.need_login,
    payload.failed,
    payload.notSupported,
    payload.not_supported,
    payload.notConnected,
    payload.not_connected,
    payload.readFailure,
    payload.read_failure,
    payload.readFailed,
    payload.read_failed,
    content.readOnly,
    content.read_only,
    content.readOnlyReward,
    content.read_only_reward,
    content.readOnlyAction,
    content.read_only_action,
    content.readOnlyMode,
    content.read_only_mode,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.failClosed,
    content.fail_closed,
    content.mock,
    content.mockMode,
    content.mock_mode,
    content.mockFallback,
    content.mock_fallback,
    content.readonly,
    content.placeholder,
    content.placeholderMode,
    content.placeholder_mode,
    content.placeholderResponse,
    content.placeholder_response,
    content.unimplemented,
    content.dataUnavailable,
    content.data_unavailable,
    content.readBlocked,
    content.read_blocked,
    content.readUnavailable,
    content.read_unavailable,
    content.routeUnavailable,
    content.route_unavailable,
    content.technicalError,
    content.technical_error,
    content.technicalMarker,
    content.technical_marker,
    content.technicalException,
    content.technical_exception,
    content.notImplemented,
    content.not_implemented,
    content.stub,
    content.writeBlocked,
    content.write_blocked,
    content.blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.backendFailure,
    content.backend_failure,
    content.paymentBackendBlocked,
    content.payment_backend_blocked,
    content.paymentStatusUnconfirmed,
    content.payment_status_unconfirmed,
    content.falseProof,
    content.false_proof,
    content.needLogin,
    content.need_login,
    content.failed,
    content.notSupported,
    content.not_supported,
    content.notConnected,
    content.not_connected,
    content.readFailure,
    content.read_failure,
    content.readFailed,
    content.read_failed,
    ...bodyValues(bodies, [
      'readOnly',
      'read_only',
      'readOnlyReward',
      'read_only_reward',
      'readOnlyAction',
      'read_only_action',
      'readOnlyMode',
      'read_only_mode',
      'fallback',
      'fallbackUsed',
      'fallback_used',
      'failClosed',
      'fail_closed',
      'mock',
      'mockMode',
      'mock_mode',
      'mockFallback',
      'mock_fallback',
      'readonly',
      'placeholder',
      'placeholderMode',
      'placeholder_mode',
      'placeholderResponse',
      'placeholder_response',
      'unimplemented',
      'dataUnavailable',
      'data_unavailable',
      'readBlocked',
      'read_blocked',
      'readUnavailable',
      'read_unavailable',
      'routeUnavailable',
      'route_unavailable',
      'technicalError',
      'technical_error',
      'technicalMarker',
      'technical_marker',
      'technicalException',
      'technical_exception',
      'notImplemented',
      'not_implemented',
      'stub',
      'writeBlocked',
      'write_blocked',
      'blocked',
      'backendBlocked',
      'backend_blocked',
      'backendFailure',
      'backend_failure',
      'paymentBackendBlocked',
      'payment_backend_blocked',
      'paymentStatusUnconfirmed',
      'payment_status_unconfirmed',
      'falseProof',
      'false_proof',
      'needLogin',
      'need_login',
      'failed',
      'notSupported',
      'not_supported',
      'notConnected',
      'not_connected',
      'readFailure',
      'read_failure',
      'readFailed',
      'read_failed'
    ]),
    ...readOnlyQueryGuardValues(payload, content, bodies)
  ]
  const falseProofFlags = [
    payload.orderProof,
    payload.order_proof,
    payload.statusProof,
    payload.status_proof,
    payload.paymentUrlProof,
    payload.payment_url_proof,
    payload.writeProof,
    payload.write_proof,
    content.orderProof,
    content.order_proof,
    content.statusProof,
    content.status_proof,
    content.paymentUrlProof,
    content.payment_url_proof,
    content.writeProof,
    content.write_proof,
    ...bodyValues(bodies, [
      'orderProof',
      'order_proof',
      'statusProof',
      'status_proof',
      'paymentUrlProof',
      'payment_url_proof',
      'writeProof',
      'write_proof'
    ])
  ]
  if (falseProofFlags.some(isFalseProofMarker)) return true
  if (hasBusinessPayload) {
    if (directFlags.some(isStrictUnavailableMarker)) return true
  } else if (directFlags.some(isActiveGuardMarker)) {
    return true
  }
  if ([payload.success, content.success, ...bodyValues(bodies, ['success'])].some((value) => value === false || unavailableToken(value) === 'false')) return true
  const markerValues = [
    payload.status,
    payload.state,
    payload.result,
    payload.code,
    payload.errorCode,
    payload.writeBlocked,
    payload.write_blocked,
    payload.blocked,
    payload.backendBlocked,
    payload.backend_blocked,
    payload.backendFailure,
    payload.backend_failure,
    payload.paymentBackendBlocked,
    payload.payment_backend_blocked,
    payload.paymentStatusUnconfirmed,
    payload.payment_status_unconfirmed,
    payload.falseProof,
    payload.false_proof,
    payload.needLogin,
    payload.need_login,
    payload.failed,
    payload.notSupported,
    payload.not_supported,
    payload.notConnected,
    payload.not_connected,
    payload.readFailure,
    payload.read_failure,
    payload.readBlocked,
    payload.read_blocked,
    payload.readUnavailable,
    payload.read_unavailable,
    payload.technicalError,
    payload.technical_error,
    payload.technicalMarker,
    payload.technical_marker,
    payload.technicalException,
    payload.technical_exception,
    payload.readFailed,
    payload.read_failed,
    payload.msg,
    payload.message,
    payload.errorMsg,
    payload.errorMessage,
    payload.reason,
    payload.dataUnavailable,
    payload.data_unavailable,
    payload.readOnlyMessage,
    payload.readOnlyReward,
    payload.read_only_reward,
    payload.readOnlyAction,
    payload.read_only_action,
    payload.readOnlyQuery,
    payload.read_only_query,
    payload.placeholder,
    payload.placeholderMode,
    payload.placeholder_mode,
    payload.placeholderResponse,
    payload.placeholder_response,
    payload.fallback,
    payload.fallbackUsed,
    payload.fallback_used,
    payload.success,
    content.status,
    content.state,
    content.result,
    content.code,
    content.errorCode,
    content.writeBlocked,
    content.write_blocked,
    content.blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.backendFailure,
    content.backend_failure,
    content.paymentBackendBlocked,
    content.payment_backend_blocked,
    content.paymentStatusUnconfirmed,
    content.payment_status_unconfirmed,
    content.falseProof,
    content.false_proof,
    content.needLogin,
    content.need_login,
    content.failed,
    content.notSupported,
    content.not_supported,
    content.notConnected,
    content.not_connected,
    content.readFailure,
    content.read_failure,
    content.readBlocked,
    content.read_blocked,
    content.readUnavailable,
    content.read_unavailable,
    content.technicalError,
    content.technical_error,
    content.technicalMarker,
    content.technical_marker,
    content.technicalException,
    content.technical_exception,
    content.readFailed,
    content.read_failed,
    content.msg,
    content.message,
    content.errorMsg,
    content.errorMessage,
    content.reason,
    content.dataUnavailable,
    content.data_unavailable,
    content.readOnlyMessage,
    content.readOnlyReward,
    content.read_only_reward,
    content.readOnlyAction,
    content.read_only_action,
    content.readOnlyQuery,
    content.read_only_query,
    content.placeholder,
    content.placeholderMode,
    content.placeholder_mode,
    content.placeholderResponse,
    content.placeholder_response,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.success,
    ...bodyValues(bodies, [
      'status',
      'state',
      'result',
      'code',
      'errorCode',
      'writeBlocked',
      'write_blocked',
      'blocked',
      'backendBlocked',
      'backend_blocked',
      'backendFailure',
      'backend_failure',
      'paymentBackendBlocked',
      'payment_backend_blocked',
      'paymentStatusUnconfirmed',
      'payment_status_unconfirmed',
      'falseProof',
      'false_proof',
      'needLogin',
      'need_login',
      'failed',
      'notSupported',
      'not_supported',
      'notConnected',
      'not_connected',
      'readFailure',
      'read_failure',
      'readBlocked',
      'read_blocked',
      'readUnavailable',
      'read_unavailable',
      'technicalError',
      'technical_error',
      'technicalMarker',
      'technical_marker',
      'technicalException',
      'technical_exception',
      'readFailed',
      'read_failed',
      'msg',
      'message',
      'errorMsg',
      'errorMessage',
      'reason',
      'dataUnavailable',
      'data_unavailable',
      'readOnlyMessage',
      'readOnlyReward',
      'read_only_reward',
      'readOnlyAction',
      'read_only_action',
      'readOnlyQuery',
      'read_only_query',
      'placeholder',
      'placeholderMode',
      'placeholder_mode',
      'placeholderResponse',
      'placeholder_response',
      'fallback',
      'fallbackUsed',
      'fallback_used',
      'success'
    ])
  ]
  return markerValues.some((value) => isUnavailableResponseMarkerForPayload(value, hasBusinessPayload))
}

export function unavailableMessage(res, fallback) {
  const data = requestErrorPayload(res)
  const safeFallback = fundingFailureFallback(fallback, FUNDS_UNAVAILABLE_MESSAGE)
  const content = contentOf(data)
  const bodies = responseBodies(data)
  const values = [
    data && data.status,
    data && data.state,
    data && data.code,
    data && data.errorCode,
    data && data.writeBlocked,
    data && data.write_blocked,
    data && data.blocked,
    data && data.backendBlocked,
    data && data.backend_blocked,
    data && data.backendFailure,
    data && data.backend_failure,
    data && data.paymentBackendBlocked,
    data && data.payment_backend_blocked,
    data && data.paymentStatusUnconfirmed,
    data && data.payment_status_unconfirmed,
    data && data.falseProof,
    data && data.false_proof,
    data && data.failed,
    data && data.notSupported,
    data && data.not_supported,
    data && data.unsupported,
    data && data.notConnected,
    data && data.not_connected,
    data && data.readFailure,
    data && data.read_failure,
    data && data.readBlocked,
    data && data.read_blocked,
    data && data.readUnavailable,
    data && data.read_unavailable,
    data && data.routeUnavailable,
    data && data.route_unavailable,
    data && data.technicalError,
    data && data.technical_error,
    data && data.technicalMarker,
    data && data.technical_marker,
    data && data.technicalException,
    data && data.technical_exception,
    data && data.readFailed,
    data && data.read_failed,
    data && data.dataUnavailable,
    data && data.data_unavailable,
    data && data.queryOnly,
    data && data.query_only,
    data && data.onlyQuery,
    data && data.only_query,
    data && data.msg,
    data && data.message,
    data && data.errorMsg,
    data && data.errorMessage,
    data && data.reason,
    data && data.readOnlyMessage,
    data && data.readOnlyAction,
    data && data.read_only_action,
    data && data.readOnlyQuery,
    data && data.read_only_query,
    data && data.fallback,
    data && data.fallbackUsed,
    data && data.fallback_used,
    data && data.success,
    content.status,
    content.state,
    content.code,
    content.errorCode,
    content.writeBlocked,
    content.write_blocked,
    content.blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.backendFailure,
    content.backend_failure,
    content.paymentBackendBlocked,
    content.payment_backend_blocked,
    content.paymentStatusUnconfirmed,
    content.payment_status_unconfirmed,
    content.falseProof,
    content.false_proof,
    content.failed,
    content.notSupported,
    content.not_supported,
    content.msg,
    content.message,
    content.errorMsg,
    content.errorMessage,
    content.reason,
    content.readOnlyMessage,
    content.readOnlyAction,
    content.read_only_action,
    content.readOnlyQuery,
    content.read_only_query,
    content.routeUnavailable,
    content.route_unavailable,
    content.technicalError,
    content.technical_error,
    content.technicalMarker,
    content.technical_marker,
    content.technicalException,
    content.technical_exception,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.success,
    ...bodyValues(bodies, [
      'status',
      'state',
      'code',
      'errorCode',
      'writeBlocked',
      'write_blocked',
      'blocked',
      'backendBlocked',
      'backend_blocked',
      'backendFailure',
      'backend_failure',
      'paymentBackendBlocked',
      'payment_backend_blocked',
      'paymentStatusUnconfirmed',
      'payment_status_unconfirmed',
      'falseProof',
      'false_proof',
      'failed',
      'notSupported',
      'not_supported',
      'unsupported',
      'notConnected',
      'not_connected',
      'readFailure',
      'read_failure',
      'readBlocked',
      'read_blocked',
      'readUnavailable',
      'read_unavailable',
      'routeUnavailable',
      'route_unavailable',
      'technicalError',
      'technical_error',
      'technicalMarker',
      'technical_marker',
      'technicalException',
      'technical_exception',
      'readFailed',
      'read_failed',
      'dataUnavailable',
      'data_unavailable',
      'queryOnly',
      'query_only',
      'onlyQuery',
      'only_query',
      'msg',
      'message',
      'errorMsg',
      'errorMessage',
      'reason',
      'readOnlyMessage',
      'readOnlyAction',
      'read_only_action',
      'readOnlyQuery',
      'read_only_query',
      'fallback',
      'fallbackUsed',
      'fallback_used',
      'success'
    ])
  ]
  if (isNeedLogin(data)) return 'Please log in to continue'
  if ([data && data.paymentStatusUnconfirmed, data && data.payment_status_unconfirmed, content.paymentStatusUnconfirmed, content.payment_status_unconfirmed, ...bodyValues(bodies, ['paymentStatusUnconfirmed', 'payment_status_unconfirmed'])].some(isActiveGuardMarker) || values.some((value) => {
    const token = unavailableToken(value)
    return token.includes('payment_status_unconfirmed') || token.includes('paymentstatusunconfirmed') || token.includes('payment status unconfirmed') || token.includes('payment-status-unconfirmed')
  })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.falseProof, data && data.false_proof, content.falseProof, content.false_proof, ...bodyValues(bodies, ['falseProof', 'false_proof'])].some(isActiveGuardMarker) || values.some((value) => {
    const token = unavailableToken(value)
    return token.includes('false_proof') || token.includes('false-proof') || token.includes('false proof') || token.includes('falseproof')
  })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.technicalError, data && data.technical_error, data && data.technicalMarker, data && data.technical_marker, data && data.technicalException, data && data.technical_exception, content.technicalError, content.technical_error, content.technicalMarker, content.technical_marker, content.technicalException, content.technical_exception, ...bodyValues(bodies, ['technicalError', 'technical_error', 'technicalMarker', 'technical_marker', 'technicalException', 'technical_exception'])].some(isActiveGuardMarker) || values.some((value) => {
    const token = unavailableToken(value)
    return token.includes('technical_marker') || token.includes('technical-marker') || token.includes('technical marker') || token.includes('technicalmarker') || token.includes('technical_error') || token.includes('technical-error') || token.includes('technical error') || token.includes('technicalerror') || token.includes('technical_exception') || token.includes('technical-exception') || token.includes('technical exception') || token.includes('technicalexception') || token.includes('技术错误') || token.includes('技术异常')
  })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.blocked, data && data.backendBlocked, data && data.backend_blocked, data && data.backendFailure, data && data.backend_failure, data && data.paymentBackendBlocked, data && data.payment_backend_blocked, content.blocked, content.backendBlocked, content.backend_blocked, content.backendFailure, content.backend_failure, content.paymentBackendBlocked, content.payment_backend_blocked, ...bodyValues(bodies, ['blocked', 'backendBlocked', 'backend_blocked', 'backendFailure', 'backend_failure', 'paymentBackendBlocked', 'payment_backend_blocked'])].some(isActiveGuardMarker) || values.some(isBlockedToken)) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.writeBlocked, data && data.write_blocked, content.writeBlocked, content.write_blocked, ...bodyValues(bodies, ['writeBlocked', 'write_blocked'])].some(isActiveGuardMarker)) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.readFailure, data && data.read_failure, data && data.readFailed, data && data.read_failed, content.readFailure, content.read_failure, content.readFailed, content.read_failed, ...bodyValues(bodies, ['readFailure', 'read_failure', 'readFailed', 'read_failed'])].some(isActiveGuardMarker) || values.some((value) => {
    const token = unavailableToken(value)
    return token.includes('read_failure') || token.includes('read-failure') || token.includes('read failure') || token.includes('read_failed') || token.includes('read-failed') || token.includes('read failed')
  })) {
    return FUNDS_READ_FAILURE_MESSAGE
  }
  if ([data && data.readOnly, data && data.readonly, data && data.read_only, ...readOnlyQueryGuardValues(data, content, bodies), data && data.readBlocked, data && data.read_blocked, data && data.readUnavailable, data && data.read_unavailable, content.readOnly, content.readonly, content.read_only, content.readBlocked, content.read_blocked, content.readUnavailable, content.read_unavailable, ...bodyValues(bodies, ['readOnly', 'readonly', 'read_only', 'readBlocked', 'read_blocked', 'readUnavailable', 'read_unavailable'])].some(isActiveGuardMarker) || values.some((value) => isUnavailableToken(value) && unavailableToken(value).includes('read'))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.readOnlyAction, data && data.read_only_action, content.readOnlyAction, content.read_only_action, ...bodyValues(bodies, ['readOnlyAction', 'read_only_action'])].some(isActiveGuardMarker)) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.dataUnavailable, data && data.data_unavailable, content.dataUnavailable, content.data_unavailable, ...bodyValues(bodies, ['dataUnavailable', 'data_unavailable'])].some(isActiveGuardMarker) || values.some((value) => {
    const token = unavailableToken(value)
    return token.includes('data_unavailable') || token.includes('data-unavailable') || token.includes('data unavailable') || token.includes('dataunavailable')
  })) {
    return FUNDS_DATA_UNAVAILABLE_MESSAGE
  }
  if ([data && data.unimplemented, data && data.notImplemented, data && data.not_implemented, content.unimplemented, content.notImplemented, content.not_implemented, ...bodyValues(bodies, ['unimplemented', 'notImplemented', 'not_implemented'])].some(isActiveGuardMarker) || values.some((value) => isUnavailableToken(value) && (unavailableToken(value).includes('unimplemented') || unavailableToken(value).includes('not_implemented') || unavailableToken(value).includes('not implemented')))) {
    return FUNDS_UNAVAILABLE_MESSAGE
  }
  if ([data && data.mock, data && data.mockFallback, data && data.mock_fallback, content.mock, content.mockFallback, content.mock_fallback, ...bodyValues(bodies, ['mock', 'mockFallback', 'mock_fallback'])].some(isActiveGuardMarker) || values.some((value) => unavailableToken(value).includes('mock'))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.fallback, data && data.fallbackUsed, data && data.fallback_used, content.fallback, content.fallbackUsed, content.fallback_used, ...bodyValues(bodies, ['fallback', 'fallbackUsed', 'fallback_used'])].some(isActiveGuardMarker) || values.some((value) => unavailableToken(value).includes('fallback'))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.stub, content.stub, ...bodyValues(bodies, ['stub'])].some(isActiveGuardMarker) || values.some((value) => unavailableToken(value) === 'stub')) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if ([data && data.notSupported, data && data.not_supported, data && data.unsupported, data && data.notConnected, data && data.not_connected, data && data.routeUnavailable, data && data.route_unavailable, data && data.queryOnly, data && data.query_only, data && data.onlyQuery, data && data.only_query, content.notSupported, content.not_supported, content.unsupported, content.notConnected, content.not_connected, content.routeUnavailable, content.route_unavailable, content.queryOnly, content.query_only, content.onlyQuery, content.only_query, ...bodyValues(bodies, ['notSupported', 'not_supported', 'unsupported', 'notConnected', 'not_connected', 'routeUnavailable', 'route_unavailable', 'queryOnly', 'query_only', 'onlyQuery', 'only_query'])].some(isActiveGuardMarker) || values.some((value) => {
    const token = unavailableToken(value)
    return token.includes('unsupported') || token.includes('not_supported') || token.includes('not supported') || token.includes('not_connected') || token.includes('not connected') || token.includes('route_unavailable') || token.includes('route unavailable') || token.includes('routeunavailable') || token.includes('query_only') || token.includes('query only') || token.includes('only query') || token.includes('只支持查询') || token.includes('仅支持查询')
  })) {
    return FUNDS_UNAVAILABLE_MESSAGE
  }
  if ([data && data.success, content.success, ...bodyValues(bodies, ['success'])].some((value) => value === false || unavailableToken(value) === 'false')) {
    return safeFallback
  }
  if ([data && data.failed, content.failed, ...bodyValues(bodies, ['failed'])].some(isActiveGuardMarker)) {
    return fundingFailureFallback(fallback, 'This feature is temporarily unavailable. Please try again later.')
  }
  return safeFallback
}

export function isOk(res) {
  return !!(res && !isNeedLogin(res) && hasOkMarker(res) && !hasUnavailableMarker(res))
}

function hasOkMarker(res) {
  const content = contentOf(res)
  const bodies = responseBodies(res)
  return [res, content, ...bodies].some((source) => {
    if (!source || typeof source !== 'object') return false
    return [
      source.status,
      source.state,
      source.result
    ].some(isOkStatusToken) || [
      source.code,
      source.errorCode
    ].some(isOkCodeToken) || [
      source.success,
      source.paySuccess,
      source.withdrawSuccess
    ].some(isPositiveFlag)
  })
}

function isOkStatusToken(value) {
  const token = unavailableToken(value)
  return ['ok', 'success', 'successful', 'succeed', 'succeeded'].includes(token)
}

function isOkCodeToken(value) {
  const token = unavailableToken(value)
  return ['0', '00', '0000', '000000', '200', 'ok', 'success'].includes(token)
}

function isPositiveFlag(value) {
  return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(unavailableToken(value))
}

export function contentOf(res) {
  if (!res) return {}
  const body = firstEnvelopeBody(res)
  return unwrapEnvelopeBody(body)
}

function responseBodies(res) {
  if (!res || typeof res !== 'object') return []
  return collectEnvelopeBodies(res)
}

function firstEnvelopeBody(source) {
  if (Array.isArray(source)) return source
  if (!source || typeof source !== 'object') return null
  const candidates = []
  let firstEmptyEnvelope = null
  for (const key of ENVELOPE_KEYS) {
    const value = source[key]
    if (Array.isArray(value)) {
      candidates.push(value)
      continue
    }
    if (value && typeof value === 'object') {
      if (Object.keys(value).length) candidates.push(value)
      if (!firstEmptyEnvelope) firstEmptyEnvelope = value
    }
  }
  const populated = candidates.find((value) => hasPayloadFields(unwrapEnvelopeBody(value)))
  if (populated) return populated
  const nonEmptyEnvelope = candidates.find((value) => Object.keys(normalizeBody(value)).length)
  if (nonEmptyEnvelope) return nonEmptyEnvelope
  if (firstEmptyEnvelope) return firstEmptyEnvelope
  return source
}

function normalizeBody(value) {
  if (Array.isArray(value)) return { list: value, dataList: value }
  return value && typeof value === 'object' ? value : {}
}

function unwrapEnvelopeBody(value, depth = 0) {
  const body = normalizeBody(value)
  if (!Object.keys(body).length || depth >= MAX_ENVELOPE_DEPTH) return body
  const nestedValues = ENVELOPE_KEYS
    .map((key) => body[key])
    .filter((nested) => nested && (typeof nested === 'object' || Array.isArray(nested)))
  const populated = nestedValues.find((nested) => hasPayloadFields(unwrapEnvelopeBody(nested, depth + 1)))
  const orderedNestedValues = populated
    ? [populated, ...nestedValues.filter((nested) => nested !== populated)]
    : nestedValues
  for (const nested of orderedNestedValues) {
    const unwrapped = unwrapEnvelopeBody(nested, depth + 1)
    if (!Object.keys(unwrapped).length) continue
    const parent = { ...body }
    ENVELOPE_KEYS.forEach((envelopeKey) => {
      delete parent[envelopeKey]
    })
    return {
      ...parent,
      ...unwrapped
    }
  }
  return body
}

function hasPayloadFields(source) {
  if (!source || typeof source !== 'object') return false
  return Object.keys(source).some((key) => {
    if (PAYLOAD_HINT_KEYS.includes(key)) return true
    if (RESPONSE_METADATA_KEYS.includes(key)) return false
    const value = source[key]
    if (Array.isArray(value)) return value.length > 0
    if (value && typeof value === 'object') return Object.keys(value).length > 0
    return value !== undefined && value !== null && String(value).trim() !== ''
  })
}

function collectEnvelopeBodies(source, depth = 0, out = []) {
  if (!source || typeof source !== 'object' || depth >= MAX_ENVELOPE_DEPTH) return out
  if (Array.isArray(source)) {
    source.forEach((item) => {
      if (item && typeof item === 'object') {
        out.push(item)
        collectEnvelopeBodies(item, depth + 1, out)
      }
    })
    return out
  }
  for (const key of SCAN_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || (typeof value !== 'object' && !Array.isArray(value))) continue
    const body = normalizeBody(value)
    if (!Object.keys(body).length) continue
    out.push(body)
    collectEnvelopeBodies(value, depth + 1, out)
  }
  return out
}

function bodyValues(bodies, keys) {
  return bodies.reduce((values, body) => {
    keys.forEach((key) => values.push(body[key]))
    return values
  }, [])
}

export function responsePayload(res) {
  if (!res || typeof res !== 'object') return {}
  const content = contentOf(res)
  return {
    ...res,
    ...content
  }
}

export function failMessage(res, fallback) {
  const data = requestErrorPayload(res)
  const safeFallback = fundingFailureFallback(fallback, FUNDS_GENERIC_FAILURE_MESSAGE)
  const content = contentOf(data)
  const bodies = responseBodies(data)
  const message = [
    data && data.msg,
    data && data.message,
    data && data.errorMsg,
    data && data.errorMessage,
    data && data.reason,
    data && data.desc,
    data && data.description,
    data && data.detail,
    content.msg,
    content.message,
    content.errorMsg,
    content.errorMessage,
    content.reason,
    content.desc,
    content.description,
    content.detail,
    ...bodyValues(bodies, ['msg', 'message', 'errorMsg', 'errorMessage', 'reason', 'desc', 'description', 'detail'])
  ].find((value) => (
    value !== undefined &&
    value !== null &&
    typeof value !== 'object' &&
    String(value).trim() &&
    !isGenericFailureMessage(value)
  ))
  if (isNeedLogin(data)) return 'Please log in to continue'
  if (hasUnavailableMarker(data)) {
    if (message && !isSuccessLikeMessage(message) && !isHardUnavailableText(message) && !hasRawTechnicalDetail(message)) return message
    return unavailableMessage(data, safeFallback)
  }
  if (message) return message
  return safeFallback
}

export function handleNeedLogin(vm, res, message = 'Please log in to continue') {
  const data = requestErrorPayload(res)
  if (!isNeedLogin(data)) return false
  promptLogin(vm, failMessage(data, message))
  return true
}

function clearLocalToken() {
  return safeRemoveStorageItem(getLocalStorage(), 'token')
}

function promptLogin(vm, message) {
  clearLocalToken()
  if (vm && typeof vm.$toast === 'function') {
    vm.$toast({ message: message || 'Please log in to continue', icon: 'info' })
  }
  if (vm && vm.$bus && typeof vm.$bus.$emit === 'function') {
    vm.$bus.$emit('openLogin')
  }
  if (vm && typeof vm.$jumpTo === 'function') {
    vm.$jumpTo('/home', {}, { replace: true })
  }
}

function isSuccessLikeMessage(value) {
  const token = paymentToken(value)
  if (!token || isUnavailableToken(token)) return false
  return [
    'ok',
    'success',
    'successful',
    'succeed',
    'succeeded',
    'accepted',
    'submitted',
    'created',
    'refreshed'
  ].some((word) => token === word || token.includes(word))
}

export function toArray(value) {
  return Array.isArray(value) ? value : []
}

function firstArrayValue(source, keys) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of keys) {
    if (Array.isArray(data[key])) return data[key]
  }
  return []
}

export function toNumber(value, fallback = 0) {
  const num = parseNumberValue(value)
  return Number.isFinite(num) ? num : fallback
}

function parseNumberValue(value) {
  if (typeof value === 'number') return value
  const raw = String(value == null ? '' : value).trim()
  if (!raw) return NaN
  let normalized = raw.replace(/[^\d,.-]/g, '')
  if (!normalized || normalized === '-' || normalized === '.' || normalized === ',') return NaN
  const isNegative = normalized.startsWith('-')
  normalized = normalized.replace(/-/g, '')
  const lastComma = normalized.lastIndexOf(',')
  const lastDot = normalized.lastIndexOf('.')
  if (lastComma > -1 && lastDot > -1) {
    normalized = lastComma > lastDot
      ? normalized.replace(/\./g, '').replace(',', '.')
      : normalized.replace(/,/g, '')
  } else if (lastComma > -1) {
    const parts = normalized.split(',')
    normalized = parts.length === 2 && parts[1].length <= 2
      ? `${parts[0].replace(/,/g, '')}.${parts[1]}`
      : normalized.replace(/,/g, '')
  } else if (lastDot > -1) {
    const parts = normalized.split('.')
    normalized = parts.length === 2 && parts[1].length === 3 && parts[0].length <= 3
      ? parts.join('')
      : parts.length > 2
        ? `${parts.slice(0, -1).join('')}.${parts.at(-1)}`
        : normalized
  }
  const num = Number(`${isNegative ? '-' : ''}${normalized}`)
  return Number.isFinite(num) ? num : NaN
}

function invalidMoneyAmount() {
  return { ok: false, amount: 0, value: '' }
}

export function normalizeMoneyAmount(value, bounds = {}) {
  const raw = String(value == null ? '' : value).trim()
  if (!/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(raw)) return invalidMoneyAmount()
  const amount = Number(raw)
  if (!Number.isFinite(amount)) return invalidMoneyAmount()
  const minAmount = toNumber(bounds.minAmount, 0)
  const maxAmount = toNumber(bounds.maxAmount, 0)
  if (minAmount > 0 && amount < minAmount) return invalidMoneyAmount()
  if (maxAmount > 0 && amount > maxAmount) return invalidMoneyAmount()
  return { ok: true, amount, value: raw }
}

export function paymentToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

export function paymentMethodKey(payment) {
  const source = payment && typeof payment === 'object' ? payment : {}
  return paymentToken(paymentKeyAlias(source) || paymentIdAlias(source))
}

const PAYMENT_ID_ALIAS_KEYS = [
  'paymentId',
  'payment_id',
  'channelId',
  'channel_id',
  'payChannelId',
  'pay_channel_id',
  'methodId',
  'method_id',
  'id'
]

const PAYMENT_KEY_ALIAS_KEYS = [
  'paymentKey',
  'payment_key',
  'channelKey',
  'channel_key',
  'channelCode',
  'channel_code',
  'methodKey',
  'method_key',
  'payKey',
  'pay_key',
  'key',
  'code',
  'paymentId',
  'payment_id'
]

function paymentIdAlias(source = {}) {
  return firstString(source, PAYMENT_ID_ALIAS_KEYS)
}

function paymentKeyAlias(source = {}) {
  return firstString(source, PAYMENT_KEY_ALIAS_KEYS)
}

export function isEmptyPaymentMethod(payment) {
  if (!payment || typeof payment !== 'object') return true
  return !paymentMethodKey(payment)
}

function hasExplicitPaymentWritableProof(payment) {
  const source = payment && typeof payment === 'object' ? payment : {}
  const writableFlags = [
    source.payWritable,
    source.pay_writable,
    source.orderWritable,
    source.order_writable,
    source.rechargeWritable,
    source.recharge_writable,
    source.channelWritable,
    source.channel_writable,
    source.paymentHandlerProof,
    source.handlerProof
  ]
  const blockingFlags = [
    source.readOnly,
    source.read_only,
    source.readOnlyAction,
    source.read_only_action,
    source.unavailable,
    source.paymentUnavailable,
    source.payment_unavailable,
    source.writeBlocked,
    source.write_blocked,
    source.blocked,
    source.backendBlocked,
    source.backend_blocked,
    source.paymentBackendBlocked,
    source.payment_backend_blocked,
    source.failClosed,
    source.fail_closed,
    source.disabled,
    source.unimplemented,
    source.stub
  ]
  return writableFlags.some(isPositiveFlag) && !blockingFlags.some(isActiveGuardMarker)
}

export function isBlockedPaymentMethod(payment) {
  const source = payment && typeof payment === 'object' ? payment : {}
  const aliasValues = [...PAYMENT_KEY_ALIAS_KEYS, ...PAYMENT_ID_ALIAS_KEYS].map((key) => source[key])
  if (isEmptyPaymentMethod(source) || aliasValues.some(isUnavailableToken)) return true
  if (hasExplicitPaymentWritableProof(source)) return false
  return hasUnavailableMarker(source)
}

export function isDisabledPaymentMethod(payment) {
  const source = payment && typeof payment === 'object' ? payment : {}
  const status = paymentToken(source.status || source.paymentStatus || source.channelStatus)
  const closeValues = [source.isClose, source.closed, source.close].map(paymentToken)
  const enabledValues = [source.enabled, source.enable, source.isEnabled, source.open, source.isOpen]
  if (['disabled', 'closed', 'off', 'offline', 'unavailable'].includes(status)) return true
  if (closeValues.some((value) => ['1', 'true', 'yes'].includes(value))) return true
  return enabledValues.some((value) => value === false || ['0', 'false', 'no'].includes(paymentToken(value)))
}

export function isUsablePaymentMethod(payment) {
  const source = payment && typeof payment === 'object' ? payment : {}
  return Boolean(paymentMethodKey(source)) && !isBlockedPaymentMethod(source) && !isDisabledPaymentMethod(source)
}

export function hasBlockedPaymentMethods(list) {
  const items = toArray(list)
  return items.some(isBlockedPaymentMethod)
}

function explicitPaymentListFrom(source, keys = ['paymentList', 'list', 'records', 'dataList']) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of keys) {
    if (Array.isArray(data[key])) return data[key]
  }
  return null
}

export function hasProvenEmptyPaymentList(payload, list) {
  const data = payload && typeof payload === 'object' ? payload : {}
  const content = contentOf(data)
  const bodies = responseBodies(data)
  const paymentList = Array.isArray(list)
    ? list
    : [data, content, ...bodies].map(source => explicitPaymentListFrom(source)).find(Array.isArray)
  const hasExplicitPaymentList = [data, content, ...bodies].some(source => Array.isArray(explicitPaymentListFrom(source)))
  if (!Array.isArray(paymentList) || paymentList.length !== 0 || !hasExplicitPaymentList) return false
  return hasServerReadProof(data, content, bodies) && !hasUnavailableMarker(data)
}

export function firstString(source, keys) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of keys) {
    const value = data[key]
    if (value !== undefined && value !== null && String(value).trim()) {
      return String(value).trim()
    }
  }
  return ''
}

export function getPaymentUrl(content) {
  return firstString(content, [
    'url',
    'payUrl',
    'paymentUrl',
    'cashierUrl',
    'checkoutUrl',
    'redirectUrl',
    'qrcode',
    'qrCode'
  ])
}

const PAYMENT_PROOF_KEYS = ['payproof', 'payurlproof', 'paymenturlproof', 'orderproof', 'statusproof', 'serverorderstatusproof']
const WITHDRAW_PROOF_KEYS = [
  'withdrawproof',
  'withdraworderproof',
  'withdrawstatusproof',
  'statusproof'
]
const WRITE_COUNT_PROOF_KEYS = ['affected', 'affectedrows', 'rowcount']
const PAYMENT_PROOF_BLOCK_KEYS = [...PAYMENT_PROOF_KEYS, 'rewardproof']
const WITHDRAW_PROOF_BLOCK_KEYS = [...PAYMENT_PROOF_BLOCK_KEYS, ...WITHDRAW_PROOF_KEYS]
const PAYMENT_URL_BLOCK_KEYS = ['url', 'payurl', 'paymenturl', 'cashierurl', 'checkouturl', 'redirecturl', 'qrcode']
const PAYMENT_BLOCK_MARKER_KEYS = [
  'readonly',
  'readonlyaction',
  'readonlyreward',
  'readonlyquery',
  'mock',
  'mockfallback',
  'stub',
  'fallback',
  'failclosed',
  'fallbackused',
  'dataunavailable',
  'notsupported',
  'notconnected',
  'notimplemented',
  'unimplemented',
  'unsupported',
  'disabled',
  'unavailable',
  'blocked',
  'backendblocked',
  'backendfailure',
  'paymentbackendblocked',
  'paymentstatusunconfirmed',
  'falseproof',
  'writeblocked',
  'readfailure',
  'readfailed',
  'readunavailable',
  'readblocked',
  'routeunavailable',
  'technicalerror',
  'technicalmarker',
  'technicalexception'
]
const PAYMENT_MESSAGE_KEYS = ['message', 'msg', 'reason', 'errmsg', 'errormessage', 'readonlymessage']
const PAYMENT_BLOCK_TEXT = [
  '未接入',
  'mock',
  'stub',
  'fallback',
  'failclosed',
  'fail closed',
  'fail_closed',
  '只读',
  '阻止假成功',
  '阻止假支付',
  'writeblocked',
  'write blocked',
  'write_blocked',
  'backendblocked',
  'backendfailure',
  'backend blocked',
  'backend_blocked',
  'backend failure',
  'backend_failure',
  'paymentbackendblocked',
  'payment backend blocked',
  'payment_backend_blocked',
  'paymentstatusunconfirmed',
  'payment status unconfirmed',
  'payment_status_unconfirmed',
  'falseproof',
  'false proof',
  'false_proof',
  'read only',
  'read-only',
  'not_connected',
  'not connected',
  'not_supported',
  'not supported',
  'not_implemented',
  'not implemented',
  'unimplemented',
  'data unavailable',
  'data_unavailable',
  'dataunavailable',
  'read failure',
  'read_failure',
  'readfailure',
  'read unavailable',
  'read_unavailable',
  'readunavailable',
  'read blocked',
  'read_blocked',
  'readblocked',
  'route unavailable',
  'route_unavailable',
  'routeunavailable',
  'technical error',
  'technical_error',
  'technicalerror',
  'technical marker',
  'technical_marker',
  'technicalmarker',
  'technical exception',
  'technical_exception',
  'technicalexception',
  '技术错误',
  '技术异常'
]
const PAYMENT_UNSAFE_PROOF_TOKENS = [
  '0',
  'false',
  'no',
  'off',
  'none',
  'null',
  'undefined',
  'placeholder',
  'mock',
  'stub',
  'fallback',
  'fallback_used',
  'read_only',
  'readonly',
  'unimplemented',
  'not_implemented',
  'not_supported',
  'not_connected',
  'data_unavailable',
  'read_failure',
  'read_unavailable',
  'read_blocked',
  'route_unavailable',
  'technical_marker',
  'technical_error',
  'technical_exception',
  'unsupported',
  'disabled',
  'unavailable',
  'blocked',
  'backend_blocked',
  'backend_failure',
  'payment_backend_blocked',
  'payment_status_unconfirmed',
  'false_proof',
  'write_blocked',
  'about:blank',
  '#',
  'javascript:void(0)'
]

function normalizePaymentProofKey(key) {
  return String(key || '').replace(/[\s_-]/g, '').toLowerCase()
}

function isFalsePaymentProofValue(value) {
  const token = paymentToken(value)
  return value === false || value === 0 || ['0', 'false', 'no', 'off'].includes(token)
}

function isBlockedPaymentProofValue(value) {
  const token = paymentToken(value)
  return isFalsePaymentProofValue(value) || isUnavailablePaymentProofToken(token)
}

function isBlockedWriteCountProofValue(value) {
  if (value === undefined || value === null || String(value).trim() === '') return false
  const count = Number(value)
  return Number.isFinite(count) && count <= 0
}

function isUnavailablePaymentProofToken(token) {
  return PAYMENT_UNSAFE_PROOF_TOKENS.includes(token) ||
    token.includes('mock') ||
    token.includes('stub') ||
    token.includes('fallback') ||
    token.includes('read_only') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token.includes('readonly') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('not_supported') ||
    token.includes('not supported') ||
    token.includes('not_connected') ||
    token.includes('not connected') ||
    token.includes('notconnected') ||
    token.includes('data_unavailable') ||
    token.includes('data unavailable') ||
    token.includes('dataunavailable') ||
    token.includes('read_failure') ||
    token.includes('read failure') ||
    token.includes('readfailure') ||
    token.includes('read_unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read_blocked') ||
    token.includes('read-blocked') ||
    token.includes('read blocked') ||
    token.includes('readblocked') ||
    token.includes('route_unavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route unavailable') ||
    token.includes('routeunavailable') ||
    token.includes('technical_error') ||
    token.includes('technical-error') ||
    token.includes('technical error') ||
    token.includes('technicalerror') ||
    token.includes('technical_exception') ||
    token.includes('technical-exception') ||
    token.includes('technical exception') ||
    token.includes('technicalexception') ||
    token.includes('blocked') ||
    token.includes('write_blocked') ||
    token.includes('write blocked') ||
    token.includes('writeblocked') ||
    token.includes('backend_blocked') ||
    token.includes('backend blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend_failure') ||
    token.includes('backend failure') ||
    token.includes('backendfailure') ||
    token.includes('payment_backend_blocked') ||
    token.includes('payment backend blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment_status_unconfirmed') ||
    token.includes('payment status unconfirmed') ||
    token.includes('paymentstatusunconfirmed') ||
    token.includes('false_proof') ||
    token.includes('false proof') ||
    token.includes('falseproof') ||
    token.includes('need_login')
}

function isPositivePaymentProofValue(value) {
  if (value === true || value === 1) return true
  if (Array.isArray(value)) return false
  if (value && typeof value === 'object') return false
  const token = paymentToken(value)
  if (!token || isFalsePaymentProofValue(value)) return false
  if (['true', '1', 'yes', 'ok', 'success', 'paid', 'created', 'submitted'].includes(token)) return true
  return !isUnavailablePaymentProofToken(token)
}

function isActivePaymentBlockValue(value) {
  if (isFalsePaymentProofValue(value)) return false
  const token = paymentToken(value)
  return value === true ||
    value === 1 ||
    ['1', 'true', 'yes', 'on'].includes(token) ||
    isUnavailablePaymentProofToken(token)
}

function isPaymentBlockMessage(value) {
  const text = paymentToken(value)
  return !!text && PAYMENT_BLOCK_TEXT.some(token => text.includes(token))
}

function hasPaymentProofBlocker(payload, seen = new Set()) {
  if (!payload || typeof payload !== 'object' || seen.has(payload)) return false
  if (hasConfirmedPaymentReadyPayload(payload)) return false
  seen.add(payload)
  return Object.entries(payload).some(([key, value]) => {
    const normalizedKey = normalizePaymentProofKey(key)
    if (PAYMENT_PROOF_BLOCK_KEYS.includes(normalizedKey) && isBlockedPaymentProofValue(value)) return true
    if (WRITE_COUNT_PROOF_KEYS.includes(normalizedKey) && isBlockedWriteCountProofValue(value)) return true
    if (PAYMENT_URL_BLOCK_KEYS.includes(normalizedKey) && isBlockedPaymentProofValue(value)) return true
    if (PAYMENT_BLOCK_MARKER_KEYS.includes(normalizedKey) && isActivePaymentBlockValue(value)) return true
    if (PAYMENT_MESSAGE_KEYS.includes(normalizedKey) && isPaymentBlockMessage(value)) return true
    return value && typeof value === 'object' && hasPaymentProofBlocker(value, seen)
  })
}

function hasConfirmedPaymentReadyPayload(payload) {
  const source = responsePayload(payload)
  if (!source || typeof source !== 'object' || Array.isArray(source)) return false
  const blockingValues = [
    source.readOnly,
    source.read_only,
    source.readOnlyAction,
    source.read_only_action,
    source.unavailable,
    source.paymentUnavailable,
    source.payment_unavailable,
    source.writeBlocked,
    source.write_blocked,
    source.blocked,
    source.backendBlocked,
    source.backend_blocked,
    source.paymentBackendBlocked,
    source.payment_backend_blocked,
    source.failClosed,
    source.fail_closed,
    source.falseProof,
    source.false_proof
  ]
  if (blockingValues.some(isActivePaymentBlockValue)) return false
  const hasUrl = isSafePaymentUrlValue(getPaymentUrl(source))
  const hasOrder = isSafeBusinessValue(getOrderNo(source))
  if (!hasUrl && !hasOrder) return false
  return [
    source.success,
    source.payWritable,
    source.pay_writable,
    source.orderWritable,
    source.order_writable,
    source.rechargeWritable,
    source.recharge_writable,
    source.paymentUrlProof,
    source.payment_url_proof,
    source.orderProof,
    source.order_proof,
    source.paymentHandlerProof,
    source.handlerProof,
    source.writeProof,
    source.write_proof,
    source.serverProof,
    source.server_proof
  ].some(isPositivePaymentProofValue)
}

function hasWithdrawProofBlocker(payload, seen = new Set()) {
  if (!payload || typeof payload !== 'object' || seen.has(payload)) return false
  seen.add(payload)
  return Object.entries(payload).some(([key, value]) => {
    const normalizedKey = normalizePaymentProofKey(key)
    if (WITHDRAW_PROOF_BLOCK_KEYS.includes(normalizedKey) && isBlockedPaymentProofValue(value)) return true
    if (WRITE_COUNT_PROOF_KEYS.includes(normalizedKey) && isBlockedWriteCountProofValue(value)) return true
    if (PAYMENT_BLOCK_MARKER_KEYS.includes(normalizedKey) && isActivePaymentBlockValue(value)) return true
    if (PAYMENT_MESSAGE_KEYS.includes(normalizedKey) && isPaymentBlockMessage(value)) return true
    return value && typeof value === 'object' && hasWithdrawProofBlocker(value, seen)
  })
}

function hasDirectPositivePaymentProof(payload) {
  if (!payload || typeof payload !== 'object') return false
  return Object.entries(payload).some(([key, value]) => (
    PAYMENT_PROOF_KEYS.includes(normalizePaymentProofKey(key)) &&
    isPositivePaymentProofValue(value)
  ))
}

const PAYMENT_URL_PROOF_KEYS = ['payproof', 'payurlproof', 'paymenturlproof', 'orderproof', 'statusproof', 'serverorderstatusproof']

function hasDirectPositivePaymentUrlProof(payload) {
  if (!payload || typeof payload !== 'object') return false
  return Object.entries(payload).some(([key, value]) => (
    PAYMENT_URL_PROOF_KEYS.includes(normalizePaymentProofKey(key)) &&
    isPositivePaymentProofValue(value)
  ))
}

function hasDirectPositiveWithdrawProof(payload) {
  if (!payload || typeof payload !== 'object') return false
  return Object.entries(payload).some(([key, value]) => {
    const normalizedKey = normalizePaymentProofKey(key)
    if (WITHDRAW_PROOF_KEYS.includes(normalizedKey)) return isPositivePaymentProofValue(value)
    const count = Number(value)
    return WRITE_COUNT_PROOF_KEYS.includes(normalizedKey) && Number.isInteger(count) && count > 0
  })
}

export function hasPaymentSuccessProof(payload) {
  return !hasUnavailableMarker(payload) && !hasPaymentProofBlocker(payload) && hasDirectPositivePaymentProof(responsePayload(payload))
}

function hasPaymentUrlSuccessProof(payload) {
  return !hasUnavailableMarker(payload) && !hasPaymentProofBlocker(payload) && hasDirectPositivePaymentUrlProof(responsePayload(payload))
}

function hasWithdrawSuccessProof(payload) {
  return !hasUnavailableMarker(payload) && !hasWithdrawProofBlocker(payload) && hasDirectPositiveWithdrawProof(responsePayload(payload))
}

export function getOrderNo(content) {
  return firstString(content, [
    'orderNo',
    'orderId',
    'recordNo',
    'payOrderNo',
    'paymentOrderNo',
    'paymentNo',
    'tradeNo',
    'wdOrderNo',
    'withdrawOrderNo',
    'withdrawId',
    'withdrawNo',
    'applyNo'
  ])
}

export function getWithdrawOrderNo(content) {
  return getOrderNo(content) || firstString(content, ['id'])
}

function isSafeBusinessValue(value) {
  const text = String(value || '').trim()
  if (!text) return false
  const token = paymentToken(text)
  if (isUnavailableToken(token)) return false
  return ![
    '0',
    'none',
    'null',
    'undefined',
    'placeholder',
    'mock',
    'about:blank',
    '#',
    'javascript:void(0)'
  ].includes(token)
}

function isSafePaymentUrlValue(value) {
  const text = String(value || '').trim()
  if (!isSafeBusinessValue(text)) return false
  const token = paymentToken(text)
  if (
    token.startsWith('#') ||
    token.startsWith('about:') ||
    token.startsWith('javascript:') ||
    token.startsWith('vbscript:') ||
    token.startsWith('data:')
  ) return false
  if (hasUnsafeUrlControlCharacter(text)) return false
  try {
    const parsed = new URL(text)
    return ['http:', 'https:'].includes(parsed.protocol) &&
      Boolean(parsed.hostname) &&
      !parsed.username &&
      !parsed.password
  } catch (e) {
    return false
  }
}

function hasUnsafeUrlControlCharacter(text) {
  return String(text || '').split('').some((char) => {
    const code = char.charCodeAt(0)
    return code <= 32 || code === 127
  })
}

function isFailureBusinessToken(value) {
  const token = paymentToken(value)
  return isUnavailableToken(token) || [
    'reject',
    'rejected',
    'cancel',
    'cancelled',
    'canceled',
    'expire',
    'expired',
    'timeout',
    'closed',
    'void',
    'voided'
  ].includes(token)
}

function isAcceptedBusinessToken(value, extra = []) {
  const token = paymentToken(value)
  const extraTokens = Array.isArray(extra) ? extra : []
  return [
    '0',
    '00',
    '0000',
    '000000',
    '200',
    'ok',
    'success',
    'successful',
    'accepted',
    'submitted',
    'created',
    'pending',
    'processing',
    'waiting',
    'wait',
    ...extraTokens
  ].includes(token)
}

function hasAcceptedBusinessMarker(res, positiveFlags = []) {
  if (!res || isNeedLogin(res) || hasUnavailableMarker(res)) return false
  const content = contentOf(res)
  const bodies = responseBodies(res)
  const flagKeys = Array.isArray(positiveFlags) ? positiveFlags : []
  return [res, content, ...bodies].some((source) => {
    if (!source || typeof source !== 'object') return false
    return [
      source.status,
      source.state,
      source.result
    ].some(isAcceptedBusinessToken) || [
      source.code,
      source.errorCode
    ].some(isOkCodeToken) || flagKeys.some((key) => isPositiveFlag(source[key]))
  })
}

export function isRechargePayReady(res) {
  if (!hasAcceptedBusinessMarker(res, ['success', 'paySuccess'])) return false
  const payload = responsePayload(res)
  const paymentUrl = getPaymentUrl(payload)
  const orderNo = getOrderNo(payload)
  if (paymentUrl && !isSafePaymentUrlValue(paymentUrl)) return false
  if (!isSafePaymentUrlValue(paymentUrl) && !isSafeBusinessValue(orderNo)) return false
  if (!hasPaymentSuccessProof(res)) return false
  const statusValues = [
    payload.paymentStatus,
    payload.payStatus,
    payload.orderStatus,
    payload.tradeStatus,
    payload.status,
    payload.state,
    payload.result
  ].filter((value) => value !== undefined && value !== null && String(value).trim() !== '')
  if (statusValues.some(isFailureBusinessToken)) return false
  if (!statusValues.length) return true
  return statusValues.some((value) => isAcceptedBusinessToken(value, [
    'unpaid',
    'pay$waiting',
    'pay_waiting',
    'pay-waiting',
    'pay waiting',
    'wait_pay',
    'waiting_pay',
    'pending_pay'
  ]))
}

export function isWithdrawAccepted(res) {
  if (!hasAcceptedBusinessMarker(res, ['success', 'withdrawSuccess'])) return false
  const payload = responsePayload(res)
  if (!isSafeBusinessValue(getWithdrawOrderNo(payload))) return false
  if (!hasWithdrawSuccessProof(res)) return false
  const statusValues = [
    payload.withdrawStatus,
    payload.auditStatus,
    payload.orderStatus,
    payload.status,
    payload.state,
    payload.result
  ].filter((value) => value !== undefined && value !== null && String(value).trim() !== '')
  if (statusValues.some(isFailureBusinessToken)) return false
  if (!statusValues.length) return true
  return statusValues.some(isAcceptedBusinessToken)
}

export function normalizeQuickSelect(list) {
  return toArray(list).filter(item => !hasUnavailableMarker(item)).map((item) => {
    const source = item && typeof item === 'object' ? item : {}
    return {
      ...source,
      amount: toNumber(source.amount, 0),
      bonus: toNumber(source.bonus, 0),
      isActive: source.isActive === true
    }
  })
}

export function normalizePaymentMethod(item) {
  const source = item && typeof item === 'object' ? item : {}
  const paymentId = paymentIdAlias(source) || paymentMethodKey(source)
  const paymentKey = paymentKeyAlias(source) || paymentId
  return {
    ...source,
    paymentId,
    paymentKey,
    quickSelect: normalizeQuickSelect(source.quickSelect),
    awardRules: toArray(source.awardRules),
    minAmount: toNumber(source.minAmount, 0),
    maxAmount: toNumber(source.maxAmount, 0),
    rechargeFees: toNumber(source.rechargeFees, 0)
  }
}

export function normalizeBankCardList(list) {
  return toArray(list).reduce((cards, item) => {
    const source = item && typeof item === 'object' ? item : {}
    if (!Object.keys(source).length || hasUnavailableMarker(source)) return cards
    const cardId = firstString(source, [
      'cardId',
      'card_id',
      'bankCardId',
      'bank_card_id',
      'id'
    ])
    const bankCard = firstString(source, [
      'bankCard',
      'bank_card',
      'accountNo',
      'account_no',
      'cardNumber',
      'card_number',
      'cardNo',
      'card_no',
      'cardNoLast4',
      'card_no_last4'
    ])
    const bankName = firstString(source, [
      'bankName',
      'bank_name',
      'bank',
      'bankTitle',
      'bank_title',
      'shortName',
      'short_name',
      'name',
      'label'
    ])
    if (!isSafeBusinessValue(cardId) || !isSafeBusinessValue(bankCard)) return cards
    cards.push({
      ...source,
      cardId,
      bankCard,
      bankName
    })
    return cards
  }, [])
}

export function normalizeBankOptions(list) {
  return toArray(list).reduce((options, item) => {
    const source = item && typeof item === 'object' ? item : {}
    if (!Object.keys(source).length || hasUnavailableMarker(source)) return options
    const value = firstString(source, [
      'bankId',
      'bank_id',
      'id',
      'bankCode',
      'bank_code',
      'code',
      'value'
    ])
    const label = firstString(source, [
      'bankName',
      'bank_name',
      'bankTitle',
      'bank_title',
      'shortName',
      'short_name',
      'name',
      'label',
      'title'
    ])
    if (!isSafeBusinessValue(value) || !isSafeBusinessValue(label)) return options
    options.push({ value, label })
    return options
  }, [])
}

export function paymentAmountBounds(payment, fallbackMin = 10, fallbackMax = 50000) {
  const source = payment && typeof payment === 'object' ? payment : {}
  const minAmount = toNumber(source.minAmount, 0)
  const maxAmount = toNumber(source.maxAmount, 0)
  return {
    minAmount: minAmount > 0 ? minAmount : fallbackMin,
    maxAmount: maxAmount > 0 ? maxAmount : fallbackMax
  }
}

export function normalizeRechargeContent(content) {
  const source = content && typeof content === 'object' ? content : {}
  const paymentList = firstArrayValue(source, [
    'paymentList',
    'list',
    'records',
    'dataList',
    'pageList',
    'items'
  ])
  return {
    paymentList: paymentList
      .map(normalizePaymentMethod)
      .filter(isUsablePaymentMethod),
    activities: toArray(source.activities),
    firstRecharge: isPositiveFlag(source.firstRecharge),
    balance: toNumber(source._balUsable || source.balance, 0),
    account: source._account || source.account || ''
  }
}

export function defaultAmountIndex(list) {
  const items = toArray(list)
  if (items.length > 1) return 1
  if (items.length > 0) return 0
  return -1
}

export function promoType(firstRecharge, activities, enabled = true) {
  if (!firstRecharge || !enabled) return null
  const firstActivity = toArray(activities)[0]
  return (firstActivity && firstActivity.code) || 'first_recharge_new_1'
}

export function openLogin(vm) {
  if (vm && vm.$bus) {
    vm.$bus.$emit('openLogin')
  } else if (vm && Object.prototype.hasOwnProperty.call(vm, 'showPopup')) {
    vm.showPopup = true
  }
}

export function showError(vm, res, fallback) {
  const data = requestErrorPayload(res)
  if (handleNeedLogin(vm, data)) return
  if (vm && vm.$toast) {
    vm.$toast({
      message: failMessage(data, fallback || (vm.$lang && vm.$lang.network_error) || FUNDS_GENERIC_FAILURE_MESSAGE),
      icon: 'cross'
    })
  }
}

export function hasLocalToken(vm) {
  return Boolean((vm && vm.token) || safeGetStorageItem(getLocalStorage(), 'token'))
}

export function safeTrackRecharge(vm, amount) {
  const value = parseInt(toNumber(amount, 0) * 0.1)
  if (!value) return
  return value
}

export function buildPayOrderData(content, extra = {}) {
  const data = content && typeof content === 'object' ? content : {}
  return {
    orderNo: getOrderNo(data),
    paymentAmount: toNumber(data.paymentAmount || extra.paymentAmount, 0),
    paymentId: data.paymentId || extra.paymentId || '',
    paymentKey: extra.paymentKey || data.paymentKey || '',
    url: getPaymentUrl(data),
    wlType: extra.wlType || data.wlType || '',
    paymentUrlProof: data.paymentUrlProof !== undefined ? data.paymentUrlProof : data.payment_url_proof,
    payProof: data.payProof !== undefined ? data.payProof : data.pay_proof,
    paymentProof: data.paymentProof !== undefined ? data.paymentProof : data.payment_proof,
    orderProof: data.orderProof !== undefined ? data.orderProof : data.order_proof,
    statusProof: data.statusProof !== undefined ? data.statusProof : data.status_proof,
    serverOrderStatusProof: data.serverOrderStatusProof !== undefined ? data.serverOrderStatusProof : data.server_order_status_proof,
    serverProof: data.serverProof !== undefined ? data.serverProof : data.server_proof,
    writeProof: data.writeProof !== undefined ? data.writeProof : data.write_proof,
    createdAt: Date.now()
  }
}

export function savePayOrderData(orderData) {
  const url = orderData && firstString(orderData, ['url'])
  if (!orderData || !isSafeBusinessValue(orderData.orderNo) || (url && !isSafePaymentUrlValue(url)) || !hasPaymentUrlSuccessProof(orderData)) return false
  return safeSetStorageItem(getSessionStorage(), 'payOrderData', JSON.stringify(orderData))
}
